import { Edit } from 'react-admin';
import { AddressForm } from 'src/Pages/Addresses/AddressForm';

export const AddressEdit = () => (
  <Edit>
    <AddressForm />
  </Edit>
);
